export type UsStateOption = {label: string; value: string};

const US_STATES_SORTED: UsStateOption[] = [
  {label: "Alabama", value: "AL"},
  {label: "Alaska", value: "AK"},
  {label: "Arizona", value: "AZ"},
  {label: "Arkansas", value: "AR"},
  {label: "California", value: "CA"},
  {label: "Colorado", value: "CO"},
  {label: "Connecticut", value: "CT"},
  {label: "Delaware", value: "DE"},
  {label: "District of Columbia", value: "DC"},
  {label: "Florida", value: "FL"},
  {label: "Georgia", value: "GA"},
  {label: "Hawaii", value: "HI"},
  {label: "Idaho", value: "ID"},
  {label: "Illinois", value: "IL"},
  {label: "Indiana", value: "IN"},
  {label: "Iowa", value: "IA"},
  {label: "Kansas", value: "KS"},
  {label: "Kentucky", value: "KY"},
  {label: "Louisiana", value: "LA"},
  {label: "Maine", value: "ME"},
  {label: "Maryland", value: "MD"},
  {label: "Massachusetts", value: "MA"},
  {label: "Michigan", value: "MI"},
  {label: "Minnesota", value: "MN"},
  {label: "Mississippi", value: "MS"},
  {label: "Missouri", value: "MO"},
  {label: "Montana", value: "MT"},
  {label: "Nebraska", value: "NE"},
  {label: "Nevada", value: "NV"},
  {label: "New Hampshire", value: "NH"},
  {label: "New Jersey", value: "NJ"},
  {label: "New Mexico", value: "NM"},
  {label: "New York", value: "NY"},
  {label: "North Carolina", value: "NC"},
  {label: "North Dakota", value: "ND"},
  {label: "Ohio", value: "OH"},
  {label: "Oklahoma", value: "OK"},
  {label: "Oregon", value: "OR"},
  {label: "Pennsylvania", value: "PA"},
  {label: "Rhode Island", value: "RI"},
  {label: "South Carolina", value: "SC"},
  {label: "South Dakota", value: "SD"},
  {label: "Tennessee", value: "TN"},
  {label: "Texas", value: "TX"},
  {label: "Utah", value: "UT"},
  {label: "Vermont", value: "VT"},
  {label: "Virginia", value: "VA"},
  {label: "Washington", value: "WA"},
  {label: "West Virginia", value: "WV"},
  {label: "Wisconsin", value: "WI"},
  {label: "Wyoming", value: "WY"},
].sort((a, b) => a.label.localeCompare(b.label));

/** US states + DC + Unknown (`UNK` last). `value` is sent to the API; `label` is display copy. */
export const US_STATE_OPTIONS: UsStateOption[] = [
  ...US_STATES_SORTED,
  {label: "Unknown", value: "UNK"},
];

/** Maps API / legacy values to a known code, or "" if unrecognized (user must re-select). */
export function coerceStateCode(raw: string | undefined | null): string {
  const t = raw?.trim();
  if (!t) return "";
  if (t === "?" || t.toUpperCase() === "UNKNOWN") return "UNK";
  const upper = t.toUpperCase();
  const byValue = US_STATE_OPTIONS.find((option) => option.value === upper);
  if (byValue) return byValue.value;
  const byLabel = US_STATE_OPTIONS.find((option) => option.label.toUpperCase() === upper);
  if (byLabel) return byLabel.value;
  return "";
}

/** Human label for a state code; falls back to the code when not in the picklist. */
export function formatUsStateLabel(code: string | undefined | null): string {
  const normalized = coerceStateCode(code);
  if (!normalized) {
    const trimmed = code?.trim();
    return trimmed ? trimmed : "—";
  }
  return US_STATE_OPTIONS.find((o) => o.value === normalized)?.label ?? normalized;
}
